module.exports = __webpack_public_path__ + "img/kt6.0c8e01d4.png";